import * as React from 'react';
import {COutlookTask} from '../../Entity/OutlookTaskObj';
import  './Task.scss';
import OutlookTask from './outlookTask';

export interface IMeetingsProps{
    data:COutlookTask;
    UpdateToDoItem;
    Phrases;
    usertimezone;
}
export default class OutlookTaskCalView extends React.Component<IMeetingsProps>{
    constructor(props) {
        super(props);
      }
    public render() {
       
        return (
                <div className='TODO' draggable onDragStart={(e)=>this.onDragStart(e)}>
                    <div  className={['calitem','ellips'].join(' ')}>
                    <OutlookTask 
                      UpdateToDoItem={this.props.UpdateToDoItem} 
                      data={this.props.data} 
                      Phrases={this.props.Phrases} 
                      usertimezone={this.props.usertimezone}
                    />
                    </div>
                </div>
        );
      }
      public onDragStart=(ev)=>{
         
        /*ev.preventDefault();

        ev.stopPropagation();
         ev.dataTransfer.effectAllowed='move';
        */
       
       /* ev.dataTransfer.setData("etag", this.props.data['@odata.etag']);
        ev.dataTransfer.setData("id", this.props.data.id);
        ev.dataTransfer.setData("type", 'outlooktask');
        ev.dataTransfer.setData("colno", this.props.data.col.toString());
        ev.dataTransfer.setData("property", 'dueDateTime');
        ev.dataTransfer.setData("source", ev.target.parentElement.id);*/
        let dragdata={
            "etag":this.props.data['@odata.etag'],
            "id":this.props.data.id,
            "type":'outlooktask',
            "colno": this.props.data.col,
            "property": 'dueDateTime',
            "source":ev.target.parentElement.id
        };
        ev.dataTransfer.setData("text/plain",JSON.stringify(dragdata));

        /*ev.dataTransfer.setData("text/plain",this.props.data.ID);
        ev.dataTransfer.setData("text/plain", 'crmmeeting');*/
       
      }
}